const receivedStatus = {
  PENDING: 0,
  RECEIVED: 1,
  EXPIRED: 2,
};

export default receivedStatus;
